import { useMutation } from 'react-query';
import request from '../../../../helpers/request';

const errorMessage = 'Не удалось установить одностороннюю передачу';

const mutationFn = ({ addressId, acceptanceId, clientId }) => {
  return request.post(
    `Acceptance/set_unilateral_transfer`,
    undefined,
    errorMessage,
    'Error',
    undefined,
    { addressId, acceptanceId, clientId }
  );
};

export const useSetUnilateralMutation = (options) =>
  useMutation(mutationFn, {
    ...options,
    onSuccess: (data, variables) => {
      if (data !== 'Error' && options?.onSuccess) {
        options.onSuccess(data, variables);
      }
    },
  });
